import * as React from 'react';

function SvgIconReplaceImage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M21.167 2h-8.334a.836.836 0 00-.833.833v5c0 .458.375.833.833.833h8.334A.836.836 0 0022 7.833v-5A.836.836 0 0021.167 2zm-.834 5h-6.666V3.667h6.666V7zM11.167 15.334H2.833a.836.836 0 00-.833.832v5c0 .459.375.834.833.834h8.334a.836.836 0 00.833-.834v-5a.836.836 0 00-.833-.832zm-.834 5H3.667V17h6.666v3.334zM7.834 6.167h2.5V4.5h-2.5A3.334 3.334 0 004.5 7.833v2.989L3.179 9.5 2 10.679l2.744 2.743a.833.833 0 001.179 0l2.744-2.744L7.488 9.5l-1.321 1.322v-2.99c0-.92.747-1.665 1.667-1.665zM19.256 10.578a.833.833 0 00-1.179 0l-2.744 2.744 1.179 1.178 1.321-1.322v2.99c0 .92-.747 1.666-1.667 1.666h-2.5V19.5h2.5a3.334 3.334 0 003.334-3.332v-2.99l1.322 1.321L22 13.321l-2.744-2.743z"
        fill="currentColor"
      />
    </svg>
  );
}

export const IconReplaceImage = React.memo(SvgIconReplaceImage);
